export default {
  ultimaDireccionUsada(state, getters, rootState) {
    if (state.user && Array.isArray(state.user.direcciones)) {
      let dir = state.user.direcciones;
      let dirSort = dir.sort((d1, d2) => {
        console.log(d1.lastUse.seconds);
        console.log(d1.lastUse.seconds + ' ' + d2.lastUse.seconds + ' bool ' + (d1.lastUse.seconds > d2.lastUse.seconds).toString())
        return d1.lastUse.seconds > d2.lastUse.seconds
      })
      return dirSort[0];
    }
    return false;
  }
}